import { IncidentItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';
import type { FiltersState } from '@/core/modules/MapPanelSources';

/**
 * Hook to extract unique filters from incidents data
 * This is used to get filters from copilot filtered incidents
 * @param incidentsData
 */
export const useIncidentsDataFilters = (incidentsData: IncidentItem[]) =>
  incidentsData.reduce<Omit<FiltersState, 'dateRange'>>(
    (acc, incident) => {
      if (!acc.incidentTypeID.includes(incident.IncidentTypeID)) {
        acc.incidentTypeID.push(incident.IncidentTypeID);
      }

      if (!acc.severityLevel.includes(incident.SeverityLevel)) {
        acc.severityLevel.push(incident.SeverityLevel);
      }

      if (!acc.incidentLocations.includes(incident.City)) {
        acc.incidentLocations.push(incident.City);
      }

      if (!acc.verificationSources.includes(incident.VerificationSource)) {
        acc.verificationSources.push(incident.VerificationSource);
      }

      if (!acc.industries.includes(incident.Industry)) {
        acc.industries.push(incident.Industry);
      }

      return acc;
    },
    {
      incidentTypeID: [],
      severityLevel: [],
      incidentLocations: [],
      verificationSources: [],
      industries: [],
    },
  );
